import {secureLocalStorageGet} from "..";
import {SystemConfiguration} from "../../configuration";
import {AppConfigurationModel, SystemModulesConfigurationModel} from "../../models";

export const isSystemConfigurationModuleEnabled = (
    array: SystemModulesConfigurationModel[] | null | undefined,
    predicate: (item: SystemModulesConfigurationModel) => boolean
): boolean => {
    return !!(array && array.some((item) => predicate(item) && item.Enable));
};

// In-memory cache for app configuration
let cachedConfig: AppConfigurationModel | null = null;

const defaultConfig: AppConfigurationModel = {
    apiEndPoint_Configurations: {alyusrApiEndpoint:"" },
    image_Configurations: {defaultWidth: 0, defaultHeight: 0},
    cache_Configurations: {maxItemCount: 0,isDefaultCachedEnabled:false, dynamicLookupCacheSettings: {}},
};

export const getAppConfig = (): AppConfigurationModel => {
    if (cachedConfig) {
        return cachedConfig;
    }
    try {
        return JSON.parse(<string>secureLocalStorageGet(
            SystemConfiguration.miscellaneous_Configurations.appConfig || ""
        )) as AppConfigurationModel;
    } catch (err) {
        return defaultConfig;
    }
};
export const clearAppConfigCache = (): void => {
    cachedConfig = null;
};

// export const getAppConfig = (): AppConfigurationModel => {
//     let result: AppConfigurationModel = {
//         apiEndPoint_Configurations: {alyusrApiEndpoint: ""},
//         image_Configurations: {defaultHeight: 0, defaultWidth: 0}
//     };
//     try {
//         result = JSON.parse(
//             <string>secureLocalStorageGet(SystemConfiguration.miscellaneous_Configurations.appConfig || "")
//         ) as AppConfigurationModel;
//     } catch (err: any) {
//         console.log('res_x_99',JSON.stringify(err));
//     }
//     return result;
// };
// export const SetAppConfiguration = (): AppConfiguration => {
//   let result: AppConfiguration = {
//     alyusrApiEndpoint: "",
//   };
//   fetch("config/appConfig.json", {
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//     },
//   })
//     .then(function (response) {
//       console.log(response);
//       return response.json();
//     })
//     .then(function (myJson) {
//       SecureLocalStorageSet(
//         SystemConfiguration.keys.appConfig || "",
//         JSON.stringify(myJson)
//       );
//       setData(myJson);
//     });
// };
